import { ConsentString } from 'consent-string';
import { getUserConfiguration } from 'owa-session-store';
import { trace } from 'owa-trace';
import fetchVendorList from '../services/fetchVendorList';

export default async function generateConsentString(
    allowAccess: boolean,
    allowPersonalization: boolean,
    allowAdSelection: boolean,
    allowContentSelection: boolean,
    allowMeasurement: boolean
) {
    const vendorList = await fetchVendorList();
    if (!vendorList) {
        trace.error('Fetching vendor list failed.');
        return null;
    }

    const consentData = new ConsentString();
    consentData.setGlobalVendorList(vendorList);

    // Generate the array of purposes.  Each purpose is represented by a number ID, and the array
    // contains the list of purposes that are allowed.
    // https://github.com/InteractiveAdvertisingBureau/GDPR-Transparency-and-Consent-Framework/blob/master/Consent%20string%20and%20vendor%20list%20formats%20v1.1%20Final.md#what-are-the-purposes-and-features-being-supported-
    const purposeFlags = [
        allowAccess,
        allowPersonalization,
        allowAdSelection,
        allowContentSelection,
        allowMeasurement,
    ];

    const allowedPurposes: number[] = [];
    purposeFlags.forEach((allowed, index) => {
        if (allowed) {
            allowedPurposes.push(index + 1);
        }
    });

    // If no purposes are allowed, no need to include any vendors
    const vendorIds = allowedPurposes.length > 0 ? vendorList.vendors.map(vendor => vendor.id) : [];

    // Determine the user's culture
    const culture = getUserConfiguration().SessionSettings.UserCulture;
    const consentLanguage = culture ? culture.split('-')[0] : 'en';

    // Set the consent data
    // 168 is the Outlook live mail cmpid
    consentData.setCmpId(168);
    consentData.setCmpVersion(1);
    consentData.setConsentScreen(1);
    consentData.setConsentLanguage(consentLanguage);
    consentData.setPurposesAllowed(allowedPurposes);
    consentData.setVendorsAllowed(vendorIds);

    // Encode the data into a web-safe base64 string
    return consentData.getConsentString();
}
